"use strict";

require("core-js/modules/es.array.iterator");

require("core-js/modules/es.map");

require("core-js/modules/es.object.to-string");

require("core-js/modules/es.string.iterator");

require("core-js/modules/web.dom-collections.iterator");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _camelCase = _interopRequireDefault(require("lodash/camelCase"));

var _isArray = _interopRequireDefault(require("lodash/isArray"));

var _isObject = _interopRequireDefault(require("lodash/isObject"));

var _forEach = _interopRequireDefault(require("lodash/forEach"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var camelCaseObject = function camelCaseObject(root) {
  var cache = new Map();

  var camelCaser = function camelCaser(obj) {
    if (!(0, _isObject.default)(obj)) {
      return obj;
    }

    var result = (0, _isArray.default)(obj) ? [] : {};
    cache.set(obj, result);
    (0, _forEach.default)(obj, function (val, key) {
      if (!cache.has(val)) {
        cache.set(val, camelCaser(val));
      }

      result[(0, _camelCase.default)(key)] = cache.get(val);
    });
    return result;
  };

  return camelCaser(root);
};

var _default = camelCaseObject;
exports.default = _default;
//# sourceMappingURL=index.js.map